import { HubSpotForm } from "@/components/site/HubSpotForm";

export function CustomReportForm() {
  return (
    <div id="custom-report" className="overflow-hidden rounded-xl border border-border bg-card p-5 sm:p-8 md:p-12 shadow-[var(--shadow-card)]">
      <div className="grid gap-8 md:grid-cols-2 md:gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-[var(--gold-deep)]">
            <span className="h-px w-8 bg-[var(--gold)]" />Custom report
          </div>
          <h3 className="mt-4 font-display text-2xl sm:text-3xl md:text-4xl font-semibold text-foreground">Want a real forecast for your firm?</h3>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            Share your website and email, we'll send a free, custom keyword opportunity report covering the highest-value rankings in your market, your top 3 competitors, and a 12-month case projection.
          </p>
          <ul className="mt-6 space-y-2 text-sm text-foreground/85">
            <li>✓ Top 25 keywords by case value in your city</li>
            <li>✓ Competitor gap analysis (who's eating your lunch)</li>
            <li>✓ Realistic 12-month case &amp; revenue projection</li>
            <li>✓ No sales call required to receive it</li>
          </ul>
        </div>
        <div>
          <HubSpotForm />
          <p className="mt-3 text-xs text-muted-foreground text-center">No spam. We never share your data. Unsubscribe anytime.</p>
        </div>
      </div>
    </div>
  );
}
